import React from 'react';

import { cn } from '@lyearn/style';

import { EmojiEnum } from '../consts';
import { baseEmojisSVGs, emojis } from '../consts';
import { emojiScaling } from '../styles';
import { MoodEmojiProps } from './types';

const MoodEmoji: React.FC<MoodEmojiProps> = React.memo((props) => {
  const { emojiId, onClick, scaleFactor, hoverScaleFactor, isActive } = props;
  const [activeEmoji, setActiveEmoji] = React.useState<null | EmojiEnum>(null);

  const emoji = emojis[emojiId];

  return (
    <>
      <li
        key={emoji.id}
        className={cn(emojiScaling(scaleFactor, hoverScaleFactor), emoji.className, {
          [`active`]: activeEmoji === emoji.id || isActive,
        })}
        role="button"
        onClick={() => onClick?.(emoji.id)}
        onMouseEnter={() => setActiveEmoji(emoji.id)}
        onMouseLeave={() => {
          setActiveEmoji(null);
        }}>
        {emoji.node}
      </li>
      {baseEmojisSVGs}
    </>
  );
});

export default MoodEmoji;
